import React, { useEffect, useState, useContext, useCallback } from "react";
import { Grid } from "@material-ui/core";
import EmbaettiFilter from "pages/tolfraedi/components/filters/EmbaettiFilter";
import KjordaemiFilter from "pages/tolfraedi/components/filters/KjordaemiFilter";
import SveitarfelagFilter from "pages/tolfraedi/components/filters/SveitarfelagFilter";
import DagsetningFraFilter from "pages/tolfraedi/components/filters/DagsetningFraFilter";
import DagsetningTilFilter from "pages/tolfraedi/components/filters/DagsetningTilFilter";
import SamantektAtkvaediTable from "../components/tables/SamantektAtkvaediTable";
import SamantektAdstodTable from "../components/tables/SamantektAdstodTable";
import NylegAtkvaediTable from "pages/tolfraedi/components/tables/NylegAtkvaediTable";
import KosningSelect from "pages/tolfraedi/components/KosningSelect";
import { getAtkvaediSummary, getLatestAtkvaediByKosning } from "common/services/apiService";
import { AppContext } from "store/AppContext";


export default function Skoda() {
  const context = useContext(AppContext);
  const [kosningId, setKosningId] = useState('');
  const [atkvaediSummary, setAtkvaediSummary] = useState({});
  const [atkvaedi, setAtkvaedi] = useState([]);
  const [filters, setFilters] = useState(null);
  const [embaettiFromFilter, setEmbaettiFromFilter] = useState('');

  const fetchAtkvaediSummary = useCallback(async () => {
    const { data, isSuccess, error } = await getAtkvaediSummary(kosningId, filters, context, {});

    if (isSuccess) {
      setAtkvaediSummary(data);
    } else {
      setAtkvaediSummary({});
      console.error(error);
    }
  }, [kosningId, filters, context]);

  const fetchLatestAtkvaediByKosning = useCallback(async () => {
    const {data, isSuccess, error } = await getLatestAtkvaediByKosning(kosningId, filters, context, []);

    if (isSuccess) {
      setAtkvaedi(data);
    } else {
      console.error(error);
    }
  }, [kosningId, filters, context]);

  useEffect(() => {
    if (kosningId !== '') {
      fetchAtkvaediSummary();
      fetchLatestAtkvaediByKosning();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kosningId]);

  // Refreshes data as soon as a filter changes
  // Note: Probably better to only update on action
  // if/when more filters are put in
  useEffect(() => {
    if (filters !== null) {
      fetchAtkvaediSummary();
      fetchLatestAtkvaediByKosning();
    }
  }, [filters, fetchAtkvaediSummary, fetchLatestAtkvaediByKosning]);

  return (
    <Grid container direction="column">
      <Grid container direction="row">
        <KosningSelect setKosningId={setKosningId} />
      </Grid>
      <Grid container direction="row" spacing={3}>
        <Grid item>
          <EmbaettiFilter
            setFilters={setFilters}
            setEmbaettiFromFilter={setEmbaettiFromFilter}
          />
        </Grid>
        <Grid item>
          <KjordaemiFilter setFilters={setFilters} />
        </Grid>
        <Grid item>
          <SveitarfelagFilter
            setFilters={setFilters}
          />
        </Grid>
        <Grid item>
          <DagsetningFraFilter 
            label={'Dagsetning frá'}
            filterName={'dagsetningFra'}
            setFilters={setFilters} />
        </Grid>
        <Grid item>
          <DagsetningTilFilter
            label={'Dagsetning til'}
            filterName={'dagsetningTil'}
            setFilters={setFilters}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12} sm={6}>
          <SamantektAtkvaediTable
            talning={atkvaediSummary}
            embaetti={embaettiFromFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SamantektAdstodTable
            talning={atkvaediSummary}
            embaetti={embaettiFromFilter}
          />
        </Grid>
        <Grid item xs={12}>
          <NylegAtkvaediTable atkvaedi={atkvaedi} embaetti={embaettiFromFilter} />
        </Grid>
      </Grid>
    </Grid>
  );
}